import { useCreateAccountProvider } from '@/lib/context';
import { IPlatformPageSection, PlatformPageSectionButton } from '@/shared/types/platform-pages';
import cN from 'classnames';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { isEmpty, map } from 'lodash-es';

interface IProps {
  content: IPlatformPageSection;
  utmSource?: string;
  redirectUrl?: string;
}

const PrimaryTextSection = ({ content, utmSource, redirectUrl }: IProps) => {
  const router = useRouter();
  const { showSignupDialogFromSourcing: showSignUpDialog } = useCreateAccountProvider();

  const btnClick = useCallback(
    (btn: PlatformPageSectionButton) => {
      if (btn?.onClick) {
        btn.onClick(router);
      } else if (btn?.btnHubUrl) {
        router.push(btn.btnHubUrl);
      } else {
        showSignUpDialog('', redirectUrl, 'home', utmSource);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [content?.buttons],
  );
  return (
    <div className="text-only-section">
      {content?.preTitle && (
        <span className="pre-title" style={{ color: content.preTitleColor }}>
          {content.preTitle}
        </span>
      )}
      {content?.title && (
        <h2 className="title" data-text={content.title} style={{ color: content.titleColor }}>
          {content.title}
        </h2>
      )}
      {content?.description && (
        <p className="description" style={{ color: content.descriptionColor }}>
          {content.description}
        </p>
      )}
      {content?.isComingSoon && <span className="coming-soon">Coming soon...</span>}

      {!isEmpty(content?.buttons) && (
        <div className="action-btn-container">
          {map(content.buttons, (btn: PlatformPageSectionButton, i: number) => {
            return (
              <div key={i} className={cN('action-btn', btn.btnClass)} onClick={() => btnClick(btn)}>
                <span>{btn.btnText}</span>
              </div>
            );
          })}
        </div>
      )}

      {!isEmpty(content?.discountText) && (
        <span className="discount-text">
          <span>{content.discountText}</span>
        </span>
      )}
    </div>
  );
};

export default PrimaryTextSection;
